import React from 'react';
import type { TFunction } from 'i18next';

export interface AddPayrollButtonProps {
  onClick: () => void;
  t: TFunction;
}

export function AddPayrollButton({ onClick, t }: AddPayrollButtonProps): React.ReactElement {
  return (
    <button onClick={onClick} className="mb-3.5 w-full cursor-pointer rounded-xl border-2 border-dashed border-stroke bg-white text-left text-small font-semibold text-brand font-sans" style={{ padding: "20px 24px" }}>
      {t("cart.addPayrollOptional")}
    </button>
  );
}
